export default "__VITE_ASSET__CWxNh_Ht__"